// Shared utility functions for photo operations

/**
 * Check if a filename is a video based on extension
 * @param {string} filename - The filename to check
 * @returns {boolean} True if the file is a video
 */
export const isVideo = (filename) => {
  const videoExtensions = [
    '.mp4', '.mov', '.avi', '.mkv', '.webm', '.m4v', '.3gp', '.flv', '.wmv',
    // Additional formats
    '.qt', '.mts', '.m2ts', '.ts', '.vob', '.ogv', '.mxf'
  ];
  const extension = filename.toLowerCase().substring(filename.lastIndexOf('.'));
  return videoExtensions.includes(extension);
};

/**
 * Get file type from filename
 * @param {string} filename - The filename to check
 * @returns {string} 'video' or 'image'
 */
export const getFileType = (filename) => {
  return isVideo(filename) ? 'video' : 'image';
};

/**
 * Generate thumbnail URL for a photo/video
 * @param {string} filename - The filename
 * @returns {string} The thumbnail URL
 */
export const getThumbnailUrl = (filename) => {
  const baseName = filename.replace(/\.[^/.]+$/, '');
  // URL encode the baseName to handle special characters
  return `https://storage.googleapis.com/jm_wedding-processed-bucket/thumbnails/${encodeURIComponent(baseName)}.webp`;
};

/**
 * Generate original file URL
 * @param {string} filename - The filename
 * @returns {string} The original file URL
 */
export const getOriginalUrl = (filename) => {
  // URL encode the filename to handle special characters
  return `https://storage.googleapis.com/jm_wedding/original/${encodeURIComponent(filename)}`;
};

/**
 * Generate processed photo URL (webp version)
 * @param {string} filename - The filename
 * @returns {string} The processed photo URL
 */
export const getProcessedPhotoUrl = (filename) => {
  const baseName = filename.replace(/\.[^/.]+$/, '');
  // URL encode the baseName to handle special characters
  return `https://storage.googleapis.com/jm_wedding-processed-bucket/photos/${encodeURIComponent(baseName)}.webp`;
};

export const getFloorplanUrl = (filename) => {
  return `https://storage.googleapis.com/jm_wedding-processed-bucket/floorplan.webp`;
};
